import decorator from 'lib/lang/decorator';
import computed from 'lib/mobx/computed';

import type {Form} from 'lib/form/form';
import {UsersSearch} from '../users-search';

export default decorator(({fieldName = 'users', searchFieldName = 'username'} = {}) =>
    (Class: typeof Form) => {

        class UsersAutocompleteForm extends Class {
            usersSearch: UsersSearch;

            constructor(options) {
                const {userStore} = options;

                super(options);

                this.userStore = userStore;
                this.usersSearch = new UsersSearch({
                    userStore,
                    value: () => this.field.get(searchFieldName).data.value,
                });

            }

            @computed get users(): ?User[] {
                const {users} = this.usersSearch;

                if (!users) {
                    return null;
                }

                const values = this.field.get(fieldName).data.fields.map(({value}) => value);
                return users.results.filter(user => values.indexOf(user) === -1).slice(0, 5);
            }
        }

        return UsersAutocompleteForm;
    },
);

